/* eslint-disable react-refresh/only-export-components */
import { TENANTS } from '@/hooks/useBranding';
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useState,
  useEffect,
} from 'react';

export const ThemeCtx = createContext<
  [string, Dispatch<SetStateAction<string>>]
>(['', () => {}]);

const applyTenantTheme = (tenantId: string) => {
  if (typeof document === 'undefined') return;

  Object.keys(TENANTS).forEach((tenantId) => {
    document.documentElement.classList.remove(tenantId);
  });

  if (tenantId && tenantId !== 'default' && tenantId !== '') {
    document.documentElement.classList.add(tenantId);
  }
};

const ThemeContext: React.FC<PropsWithChildren> = ({ children }) => {
  const themeState = useState('default');
  const [theme] = themeState;

  useEffect(() => {
    applyTenantTheme(theme);
  }, [theme]);

  return <ThemeCtx.Provider value={themeState}>{children}</ThemeCtx.Provider>;
};

export default ThemeContext;
